import axios from 'axios';
import { getAuthHeaders, toQueryString } from '../../utils/utils';

export async function fetchAll(filters = {}) {
  try {
    // console.log('filters get MENU', filters);
    let url = `${window.config.API_URL_USER}menu`;

    if (Object.keys(filters).length) {
      url = `${url}?${toQueryString(filters)}`;
    }

    const res = await axios.get(url, {
      //   headers: getAuthHeaders(getState()),
    });

    if (res.status === 201) {
      return res.data.data;
    }

    return [];
  } catch (err) {
    console.log('Error Get Menu', err);
    throw new Error('Error Get Menu');
    // return [];
  }
}

export async function fetchCurrent(filters = {}) {
  try {
    let url = `${window.config.API_URL_USER}menu/currentMenu`;

    if (Object.keys(filters).length) {
      url = `${url}?${toQueryString(filters)}`;
    }

    const res = await axios.get(url, {
      //   headers: getAuthHeaders(getState()),
    });

    if (res.status === 201) {
      return res.data.data;
    }

    return [];
  } catch (err) {
    console.log('Error Get Menu', err);
    throw new Error('Error Get Menu');
    // return [];
  }
}

// export async function fetchAllMenusSelect(id) {
export async function fetchAllMenusSelect(filters) {
  try {
    // const url = `${window.config.API_URL_USER}menu/select?PerfilId=${id}`;
    let url = `${window.config.API_URL_USER}menu/select`;

    if (Object.keys(filters).length) {
      url = `${url}?${toQueryString(filters)}`;
    }

    const res = await axios.get(url, {
    });

    if (res.status === 201) {
      return res.data.data;
    }
    throw new Error();

  } catch (err) {
    throw new Error();
  }
};

export async function upsertMenuClient(cliRut, data) {
  try {
    console.log(cliRut, data);
    const url = `${window.config.API_URL_USER}menu/${cliRut}`;

    const res = await axios.put(url, data, {
      //   headers: getAuthHeaders(getState()),
    });

    if (res.status === 201) {
      return res.data.data;
    }

    throw new Error();
  } catch (error) {
    console.log('Error update', error);
    throw new Error();
  }
}
